export const extensionName = 'inline-command-palette';
export const paletteMarkName = `${extensionName}-paletteMark`;
export const trigger = '/';
